import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/context/ThemeContext";
import { LiveScoresProvider } from "@/context/LiveScoresContext";
import ReactDOM from "react-dom/client"; // Import from 'react-dom/client'
import { store } from "./lib/redux/store";
import { Provider } from "react-redux";
import "./index.css";

import { BrowserRouter } from "react-router-dom";

import KeoBongVipPlugin from "./components/KeoBongVipPlugin";

const isReactBuild = process.env.REACT_APP_BUILD_TARGET === "react";

if (isReactBuild) {
  renderApps("keobongvip-root");
}

const componentMap = {
  keobongvip: KeoBongVipPlugin,
};

function App({ league, type, activeTab, hideHeader }) {
  const Component = componentMap[type] || (() => <div>Unknown type</div>);
  return <Component league={league} activeTab={activeTab} hideHeader={hideHeader} />;
}

function renderApps(className) {
  const rootElements = document.getElementsByClassName(className);

  Array.from(rootElements).forEach((rootElement) => {
    const type = rootElement.getAttribute("data-type");
    const league = rootElement.getAttribute("data-league");
    const theme = rootElement.getAttribute("data-theme");
    const activeTab = rootElement.getAttribute("data-tab") || "all";
    const hideHeader = (rootElement.getAttribute("data-hide-header") || "").toLowerCase() === "true";
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Suspense fallback={<p>Loading...</p>}>
        <Provider store={store}>
          <ThemeProvider initialTheme={theme}>
            <BrowserRouter>
            <HelmetProvider>
              <LiveScoresProvider>
                <div className="keobongvip-container">
                  <App type={type} league={league} activeTab={activeTab} hideHeader={hideHeader} />
                </div>
              </LiveScoresProvider>
            </HelmetProvider>
            </BrowserRouter>
          </ThemeProvider>
        </Provider>
      </Suspense>
    );
  });
}
